"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classNames = require("classnames");
exports.iconDefaultProps = {
    spinning: false,
    width: '24px',
    height: '24px'
};
exports.iconPropTypes = {
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    spinning: PropTypes.bool
};
/**
 * The `SvgIcon` component allows you to use your own SVG graphics to create
 * icons.
 * It can be used if the desired icon is not included in the [standard icon
 * set](#!/Icons).
 */
exports.SvgIcon = function (props) {
    var children = props.children, g = props.g, className = props.className, viewBox = props.viewBox, title = props.title, idGenerator = props.idGenerator, onClick = props.onClick, other = __rest(props, ["children", "g", "className", "viewBox", "title", "idGenerator", "onClick"]);
    var componentClassName = classNames('ee_svg-icon', className);
    var drawing = children;
    if (g) {
        drawing = React.createElement("g", { dangerouslySetInnerHTML: { __html: g } });
    }
    var titleId = 'title-' + idGenerator.next();
    return (React.createElement("svg", __assign({}, other, { onClick: onClick, className: componentClassName, focusable: "false", viewBox: viewBox, "aria-hidden": title ? 'false' : 'true', role: "img", "aria-labelledby": title ? titleId : '' }),
        title && React.createElement("title", { id: titleId }, title),
        drawing));
};
var defaultProps = {
    viewBox: '0 0 24 24',
    title: undefined,
    g: undefined,
    idGenerator: undefined,
    className: undefined,
    children: undefined,
    onClick: undefined
};
var propTypes = {
    title: PropTypes.string,
    viewBox: PropTypes.string,
    g: PropTypes.string,
    idGenerator: PropTypes.any,
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
    onClick: PropTypes.func
};
exports.SvgIcon.defaultProps = defaultProps;
exports.SvgIcon.propTypes = propTypes;
exports.default = exports.SvgIcon;
//# sourceMappingURL=SvgIcon.js.map